import { render, staticRenderFns } from "./ServicesDescription.vue?vue&type=template&id=04dd4384"
import script from "./ServicesDescription.vue?vue&type=script&lang=js"
export * from "./ServicesDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports